import React, { useState } from 'react';

import { SortIcon } from '~/src/dash/components/sorts/common';
import { IListViewTableColumnInfo, Order } from '~/src/dash/components/tables/ListViewTable/common';
import { FONT_WEIGHT } from '~/src/dash/components/text/common';
import { Col, Cols, fontSizing, spacing, Text } from '~/src/dash/publicaUI';
import { publicaColors } from '~/src/dash/utils/colors';

interface ISortByPillProps {
  handleSelectSortBy: (orderByKey: string) => void;
  isActive: boolean;
  sort: IListViewTableColumnInfo;
}

const SortByPill = ({ handleSelectSortBy, isActive, sort }: ISortByPillProps) => {
  const [isHovered, setIsHovered] = useState<boolean>(false);

  return (
    <button
      style={{
        display: 'inline-block',
        borderWidth: 0,
        margin: 0,
        padding: '6px 16px',
        borderRadius: '6px',
        lineHeight: 'inherit',
        fontFamily: 'inherit',
        fontStyle: 'inherit',
        fontSize: fontSizing.extraSmall,
        fontWeight: FONT_WEIGHT.bold,
        color: isActive ? publicaColors.jungleGreen : publicaColors.black,
        backgroundColor: isActive
          ? publicaColors.honeydew
          : isHovered
          ? publicaColors.lightGray
          : publicaColors.veryLightGray,
        cursor: 'pointer',
      }}
      onClick={() => handleSelectSortBy(sort.key)}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      <Cols
        gap='2px'
        style={{
          alignItems: 'center',
        }}
      >
        {sort.sortIcon && (
          <Col>
            <SortIcon
              color={isActive ? publicaColors.jungleGreen : publicaColors.black}
              iconKey={sort.sortIcon}
            />
          </Col>
        )}
        <Col>{sort.sortLabel || sort.label}</Col>
      </Cols>
    </button>
  );
};

interface ISortByRowProps {
  currentOrder: Order;
  currentOrderBy: string;
  handleSelectSortBy: (orderByKey: string) => void;
  sorts: IListViewTableColumnInfo[];
}

export const SortByRow = ({
  currentOrder,
  currentOrderBy,
  handleSelectSortBy,
  sorts,
}: ISortByRowProps) => {
  return (
    <Cols max largeHorizontalPadding style={{ position: 'relative' }}>
      {/* SORT BY LABEL */}
      <Col style={{ minWidth: '104px' }}>
        <Cols
          gap={spacing.small}
          style={{
            position: 'relative',
            alignItems: 'center',
            height: '42px',
          }}
        >
          <Col paddingTop='4px'>
            <img src='/assets/shared/svg/SortBy12px.svg' width='15px' />
          </Col>
          <Col>
            <Text small bold>
              Sort By
            </Text>
          </Col>
        </Cols>
      </Col>
      <Col flex>
        <Cols
          wrap
          style={{
            alignItems: 'center',
            padding: '6px 8px 5px 0px',
            columnGap: '10px',
            rowGap: spacing.extraSmall,
          }}
        >
          {sorts.map((sort) => {
            const isDefaultOrder = currentOrder === sort.defaultOrderDirection;
            const isActive =
              (currentOrderBy === sort.key && isDefaultOrder) ||
              (currentOrderBy === sort.orderByKey && isDefaultOrder);
            return (
              <Col>
                <SortByPill
                  isActive={isActive}
                  handleSelectSortBy={handleSelectSortBy}
                  sort={sort}
                />
              </Col>
            );
          })}
        </Cols>
      </Col>
    </Cols>
  );
};
